import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-phone",
  "use": "icon-phone-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-phone\">\n<path d=\"M9 1C4.6 1 1 4.6 1 9C1 13.4 4.6 17 9 17C13.4 17 17 13.4 17 9C17 4.6 13.4 1 9 1ZM12.8 12L12.4 12.4L12.3 12.5L12.2 12.6C11.7 13.1 10 13.8 7 10.9C4.2 8.1 5 6.4 5.4 5.9L6.1 5.2C6.4 4.9 6.9 4.9 7.2 5.2L8.2 6.2C8.5 6.5 8.5 7 8.2 7.3L7.6 7.8L7.5 8C7.2 8.3 7.2 8.4 7.6 8.8L9.1 10.2C9.8 10.8 9.9 10.8 10.2 10.6L10.7 10C11 9.7 11.5 9.6 11.8 9.9L12.8 10.9C13.1 11.2 13.1 11.7 12.8 12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol